import { Injectable, inject } from '@angular/core';
import {combineLatest, Observable} from 'rxjs';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {map} from 'rxjs/operators';


@Injectable({
  providedIn: "root"
})
export class ResponsiveLayoutService {
  private breakpointObserver = inject(BreakpointObserver);


  isMobile$: Observable<boolean>;

  isMobilePortait$: Observable<boolean>;

  isPhone$: Observable<boolean>;

  isTablet$: Observable<boolean>;

  isTabletLandscape$: Observable<boolean>;

  isTabletPortrait$: Observable<boolean>;

  isPhonePortrait$: Observable<boolean>;

  isPhoneLandscape$: Observable<boolean>;

  isLarge$: Observable<boolean>;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {

    this.isMobile$ = this.breakpointObserver.observe([
      '(max-width: 959px)',
    ])
      .pipe(
        map(result => result.matches)
      );

    this.isPhonePortrait$ = this.breakpointObserver.observe([
      Breakpoints.HandsetPortrait
    ])
      .pipe(
        map(result => result.matches)
      );

    this.isMobilePortait$ = this.breakpointObserver.observe([
      Breakpoints.HandsetPortrait,
      Breakpoints.TabletPortrait
    ])
      .pipe(
        map(result => result.matches)
      );


    this.isPhoneLandscape$ = this.breakpointObserver.observe([
      Breakpoints.HandsetLandscape
    ])
      .pipe(
        map(result => result.matches)
      );


    this.isTabletLandscape$ = this.breakpointObserver.observe([
      Breakpoints.TabletLandscape
    ])
      .pipe(
        map(result => result.matches)
      );

    this.isTabletPortrait$ = this.breakpointObserver.observe([
      Breakpoints.TabletPortrait
    ])
      .pipe(
        map(result => result.matches)
      );

    this.isLarge$ = this.breakpointObserver.observe([
      Breakpoints.Large
    ])
      .pipe(
        map(result => result.matches)
      );

    this.isPhone$ = this.breakpointObserver.observe([
      Breakpoints.Handset
    ])
      .pipe(
        map(result => result.matches)
      );

    this.isTablet$ = this.breakpointObserver.observe([
      Breakpoints.Tablet
    ])
      .pipe(
        map(result => result.matches)
      );

  }

  matchesAny(...sizes:string[]): Observable<boolean> {
    return combineLatest(sizes.map(size => this.breakpointObserver.observe(size)))
      .pipe(
        map( results => results.some(result => result.matches))
      );
  }

}
